import React, {useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import IsaacCommandBar from "../../components/isaacCommandBar/IsaacCommandBar";
import styles from "./constructionsNew.module.scss";
import useConstructionsNewPageHook from "./hooks/useConstructionsNewPageHook";
import { useTranslation } from "react-i18next";
import {type RootState } from "../../store";
import type ConstructionListItem from "./types/ConstructionListItem";
import { select } from "./constructionsNewSlice";
import ConstructionsNewFilters from "./components/filters/ConstructionsNewFilters";
import ConstructionsNewTable from "./components/table/ConstructionsNewTable";

import EditConstructionsNewDialog from "./components/editConstructionsNewDialog/EditConstructionsNewDialog";
import IsaacConfirmationModal from "../../components/isaacConfirmationModal/IsaacConfirmationModal";
import AddRemoveTagDialog from "./components/tags/AddRemoveTagDialog";

const ConstructionsNew: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation(["common"]);

    const {page, loading, pagination} = useSelector((state: RootState) => state.constructionsNew);
    const selectedConstructions = useMemo(() => page.filter(c => c.isSelected), [page]);

    const {
        isTagDialogHidden,
        isDeleteConfirmationOpen,
        isEditModalOpen,
        tagModalType,
        commandBarItems,
        setTagDialogHidden,
        handleDeleteConstructions,
        handleDeleteConfirmationDismiss,
        handleBulkEditDismiss,
    } = useConstructionsNewPageHook();
    
    const handleSelection = (constructionsSelection: ConstructionListItem[]): void => {
        dispatch(select(constructionsSelection));
    };

    return (
        <section className={`${styles.results} ms-motion-slideLeftIn`}>
            <div className={styles.titleContainer}>
                <div className={styles.commandBar}>
                    <IsaacCommandBar items={commandBarItems} farItems={[]} />
                 </div>

                 <ConstructionsNewFilters />
                 <ConstructionsNewTable
                     loading={loading}  
                     page={page}
                     pagination={pagination}
                     handleSelection={handleSelection}
                 /> 
                 <AddRemoveTagDialog
                    type={tagModalType}
                    isHidden={isTagDialogHidden}
                    handleDialogDismiss={setTagDialogHidden}
                />
                {isEditModalOpen && (
                  <EditConstructionsNewDialog
                    isOpen={isEditModalOpen}
                    onDismiss={handleBulkEditDismiss}
                    selectedConstructions={selectedConstructions}
                  />
                )}
        
                <IsaacConfirmationModal
                  detailsText={t("deleteConstructionWarning")}
                  isOpen={isDeleteConfirmationOpen}
                  onConfirm={handleDeleteConstructions}
                  onDismiss={handleDeleteConfirmationDismiss}
                />
            </div>
        </section>
    );
};

export default ConstructionsNew;